import { apiService } from "../../../services/api";
import { APIServicePath } from "../../../services/api/api-service-impl";
import { toPageInfo } from "../../_common/DataConverter";
import { TableTitle, MoreOptions, Icon } from "../../../components/Component";
import { isTextSelected } from "../../../utils/Functions";
import { dateToShow } from "../../../utils";
import moment from "moment";
import React, { useState } from "react";
import { Popover, PopoverHeader, PopoverBody } from "reactstrap";
import { ProgressStatusBadge } from "../../../components/badge/StatusBadge";
import { isAllowToAccess, UserPermissionType, UserActionType } from "../../../services/permission/permission";

// Component for showing extend date tooltip in due date column
const ExtendDateTooltip = ({ rowId, extendDate, extendReason }) => {
  const [mouseEnter, setMouseEnter] = useState(false);
  const tooltipId = `extend-tooltip-${rowId}`;

  return (
    <React.Fragment>
      <span
        className="ms-2"
        id={tooltipId}
        onMouseEnter={() => setMouseEnter(true)}
        onMouseLeave={() => setMouseEnter(false)}
        style={{ cursor: "pointer", flexShrink: 0 }}
      >
        <Icon name="info" className="text-primary" />
      </span>
      <Popover placement="right" isOpen={mouseEnter} target={tooltipId}>
        <PopoverHeader>Extend Information</PopoverHeader>
        <PopoverBody style={{ maxWidth: "300px", whiteSpace: "pre-wrap" }}>
          <div>
            <strong>Reason:</strong> {extendReason}
          </div>
        </PopoverBody>
      </Popover>
    </React.Fragment>
  );
};

// Generic component for cells with hover popover
const CellWithPopover = ({
  row,
  onView,
  value,
  popoverContent,
  popoverTitle,
  cellId,
  isDate = false,
  truncate = false,
}) => {
  const [mouseEnter, setMouseEnter] = useState(false);
  const hasValue = value !== null && value !== undefined && value !== "";

  if (!hasValue) {
    return <div onClick={() => onView(row)}>-</div>;
  }

  const displayValue = isDate ? dateToShow(moment(value).format("YYYY-MM-DD")) : value;
  const showPopover = popoverContent && popoverContent !== null && popoverContent !== "";

  return (
    <React.Fragment>
      <div
        className="d-flex align-items-center"
        id={`${cellId}-${row.id}`}
        onMouseEnter={() => setMouseEnter(true)}
        onMouseLeave={() => setMouseEnter(false)}
        onClick={() => onView(row)}
      >
        <span
          className="me-1"
          style={
            truncate
              ? {
                  maxWidth: "200px",
                  display: "inline-block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }
              : {}
          }
        >
          {displayValue}
        </span>
        {showPopover && <Icon name="info" className="text-primary" style={{ cursor: "help", flexShrink: 0 }} />}
      </div>
      {showPopover && (
        <Popover placement="right" isOpen={mouseEnter} target={`${cellId}-${row.id}`}>
          <PopoverHeader>{popoverTitle}</PopoverHeader>
          <PopoverBody style={truncate ? { maxWidth: "300px", whiteSpace: "pre-wrap" } : {}}>
            {popoverContent}
          </PopoverBody>
        </Popover>
      )}
    </React.Fragment>
  );
};

//***************************API's*********************************/
export function saveProgressReportAPI(params, callback) {
  apiService
    .postCall(APIServicePath.progressReport, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function listProgressReportAPI(params, callback) {
  apiService
    .postCall(APIServicePath.progressReportList, params)
    .then((data) => {
      let list = data?.list ?? [];
      let pageInfo = data?.pageInfo ? toPageInfo(data.pageInfo) : null;
      callback({ list, pageInfo }, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function getProgressReportDetailAPI(params, callback) {
  apiService
    .postCall(APIServicePath.progressReportDetail, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function removeProgressReportAPI(params, callback) {
  apiService
    .postCall(APIServicePath.progressReportRemove, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function exportProgressReportAPI(params, callback) {
  apiService
    .postCall(APIServicePath.exportProgressReport, params, 10 * 60 * 1000)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

export function extendProgressReportAPI(params, callback) {
  apiService
    .postCall(APIServicePath.progressReportExtend, params)
    .then((data) => {
      callback(data, null);
    })
    .catch((error) => {
      callback(null, error);
    });
}

//***************************Table Data*********************************/
export const ReportTableData = (onViewClick, onEdit, onRemove, onExtend, showEditColumn = true) => {
  const onView = (row) => {
    if (isTextSelected()) {
      return;
    }
    // onViewClick(row);
  };

  return [
    {
      name: <TableTitle title={"Due Date"} />,
      id: "dueDate",
      sortable: false,
      style: {
        color: "black",
      },
      cell: (row) => {
        const hasExtendReason =
          row?.extendReason !== null && row?.extendReason !== undefined && row?.extendReason !== "";

        return (
          <div className="d-flex align-items-center" id={`due-date-${row.id}`} onClick={() => onView(row)}>
            <span>{row?.dueDate ? dateToShow(moment(row.dueDate).format("YYYY-MM-DD")) : "-"}</span>
            {hasExtendReason && (
              <ExtendDateTooltip rowId={row.id} extendDate={row.extendedDate} extendReason={row?.extendReason} />
            )}
          </div>
        );
      },
    },
    {
      name: <TableTitle title={"Completed Date"} />,
      id: "completedDate",
      sortable: false,
      style: {
        color: "black",
      },
      cell: (row) => (
        <div onClick={() => onView(row)}>
          {row?.completedDate ? dateToShow(moment(row.completedDate).format("YYYY-MM-DD")) : "-"}
        </div>
      ),
    },
    {
      name: <TableTitle title={"Completed By"} />,
      id: "completedBy",
      sortable: false,
      style: {
        color: "black",
      },
      cell: (row) => (
        <div onClick={() => onView(row)}>
          {row?.completedBy
            ? typeof row.completedBy === "string"
              ? row.completedBy
              : `${row.completedBy.firstName || ""} ${row.completedBy.lastName || ""}`.trim() || "-"
            : "-"}
        </div>
      ),
    },
    {
      name: <TableTitle title={"Status"} />,
      id: "status",
      sortable: false,
      style: {
        color: "black",
      },
      cell: (row) => (
        <div onClick={() => onView(row)}>
          <ProgressStatusBadge status={row?.status} />
        </div>
      ),
    },
    {
      name: <TableTitle title={"Attachments"} />,
      id: "attachments",
      sortable: false,
      style: {
        color: "black",
      },
      cell: (row) => (
        <div onClick={() => onView(row)}>
          {row?.attachments !== undefined && row?.attachments !== null && row.attachments > 0 ? row.attachments : "-"}
        </div>
      ),
    },
    // {
    //   name: <TableTitle title={"Notes"} />,
    //   id: "comments",
    //   sortable: false,
    //   style: {
    //     color: "black",
    //   },
    //   cell: (row) => (
    //     <CellWithPopover
    //       row={row}
    //       onView={onView}
    //       value={row?.comments}
    //       popoverContent={row?.comments}
    //       // popoverTitle="Notes"
    //       cellId="notes"
    //       isDate={false}
    //       truncate={true}
    //     />
    //   ),
    // },
    {
      name: <TableTitle title={""} align="end" />,
      right: true,
      style: {
        fontSize: "20px",
      },
      width: "100px",
      cell: (row) => (
        <MoreOptions
          options={[
            {
              icon: "edit",
              text: "Edit",
              action: () => {
                onEdit(row);
              },
              hide: row?.status === "COMPLETED" || !isAllowToAccess(UserPermissionType.report, UserActionType.edit),
            },
            {
              icon: "eye",
              text: "View",
              action: () => {
                onEdit(row);
              },
              hide: row?.status !== "COMPLETED",
            },
            {
              icon: "calendar-alt",
              text: "Extend",
              action: () => {
                onExtend(row);
              },
              hide: row?.status === "COMPLETED",
            },
            {
              icon: "trash",
              text: "Remove",
              action: () => {
                onRemove(row);
              },
            },
          ]}
        />
      ),
    },
  ];
};
